"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const dls_react_1 = require("@americanexpress/dls-react");
const formik_1 = require("formik");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const InputField = ({ name, label, hint = '', className = '', autoComplete, type, isRequired = false, 'aria-required': ariaRequired, }) => {
    const [field, meta] = (0, formik_1.useField)(name);
    const { formatMessage } = (0, react_intl_1.useIntl)();
    const labelText = `${label}${isRequired ? '' : ` ${formatMessage({ id: 'optionalTag' })}`}`;
    const errorId = `${name}-error`;
    const hasError = Boolean(meta.touched && meta.error);
    const required = isRequired || ariaRequired;
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(dls_react_1.Input, { id: name, hint: hint, label: labelText, autoComplete: autoComplete, type: type, required: required, "aria-required": ariaRequired, "aria-invalid": hasError || undefined, "aria-describedby": hasError ? errorId : undefined, name: field.name, value: field.value, onChange: field.onChange, onBlur: field.onBlur }),
        hasError && (react_1.default.createElement(dls_react_1.ComponentLevelNotification, { id: errorId, status: "error", role: "alert" }, meta.error))));
};
exports.default = InputField;
